const cutFont = (value, length) => {
  if (value.length <= length) {
    return value
  } else {
    return value.slice(0, length) + '...'
  }
}

const timeFormat = (value, type) => {
  const timetamp = Number(value)
  const date = new Date(timetamp)
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  // const hour = date.getHours()
  // const minute = date.getMinutes()
  // const second = date.getSeconds()
  let result = ''
  switch (type) {
    case 1:
      result = `${year}-${month}-${day}`
      break
    case 2:
      result = `${year}年${month}月${day}日`
      break
    default:
      result = `${year}-${month}-${day}`
      break
  }
  return result
}

export {
  cutFont,
  timeFormat
}
